import { SxProps } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { PREDICAMENT_STATE_NO, PREDICAMENT_STATE_YES } from "core/consts";
import { PredicamentState } from "core/types";
import RadioGroupV2, { RadioOptionV2 } from "ds_legacy/components/RadioGroupV2";
import { RADIO_WHITE_BACKGROUND } from "ds_legacy/materials/colors";
import { padding, sizing } from "ds_legacy/materials/metrics";
import {
  PatientFormSubheading,
  Section,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SectionThree = () => {
  const translations = useTranslations();

  const options: RadioOptionV2<PredicamentState>[] = [
    {
      label: translations.actions.no,
      value: PREDICAMENT_STATE_NO,
    },
    {
      label:
        translations.patientForms.drvGeneralForm.sectionThreeNew.yesIncludeForm,
      value: PREDICAMENT_STATE_YES,
    },
  ];

  return (
    <Section
      title={translations.patientForms.drvGeneralForm.sectionThreeNew.title}
    >
      <PatientFormSubheading style={{ padding: padding(0, 0, 1) }}>
        {translations.patientForms.drvGeneralForm.sectionThreeNew.subtitle}
      </PatientFormSubheading>
      <RadioGroupV2
        elementName="care_person_necessary"
        formControlLabelSx={{ marginLeft: 0, paddingBottom: sizing(0.5) }}
        formLabelSx={visuallyHidden as SxProps}
        label={
          translations.patientForms.drvGeneralForm.sectionThreeNew.subtitle
        }
        options={options}
        radioSx={RADIO_WHITE_BACKGROUND}
      />
    </Section>
  );
};
